import { forwardRef } from 'react'
import type { ImgHTMLAttributes } from 'react'

type ResponsiveImageProps = {
  src: string
  alt: string
  avifSrc?: string
  width?: number
  height?: number
  className?: string
  loading?: 'lazy' | 'eager'
  decoding?: 'async' | 'sync' | 'auto'
} & Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'>

/**
 * Responsive image with AVIF source and original fallback.
 * Drop an `.avif` file alongside the main image and pass it as `avifSrc`.
 */
export const ResponsiveImage = forwardRef<HTMLPictureElement, ResponsiveImageProps>(
  (
    { src, alt, avifSrc, width, height, className = '', loading = 'lazy', decoding = 'async', ...rest },
    ref
  ) => {
    return (
      <picture ref={ref} className={className}>
        {avifSrc && <source srcSet={avifSrc} type="image/avif" />}
        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          loading={loading}
          decoding={decoding}
          className="h-full w-full object-cover"
          {...rest}
        />
      </picture>
    )
  }
)
ResponsiveImage.displayName = 'ResponsiveImage'
